import uploadspracticeAreaspagebannerbgimagepracticeAreasBannerJpg from "$lib/data/generated/uploads/practice areas/PageBanner/bgImage/Practice Areas Banner.jpg";

export const uploads = {
  "uploads/practice areas/PageBanner/bgImage/Practice Areas Banner.jpg": uploadspracticeAreaspagebannerbgimagepracticeAreasBannerJpg
};